export default __webpack_public_path__ + "static/media/c001-general2024-1.cc0a81ae.png";